import { useState } from 'react';
import { CoreBox } from '@youscience/core';
import { FormNames } from '@youscience/commonapp-service-common';

import ActionButton from '@components/ActionButton';
import { ConfirmationMessage } from '@components/ConfirmationMessage';

import WarningAmberIcon from '@images/Recommender/warning-amber.svg?react';

const FORMS_WITH_UNSUBMIT: FormNames[] = [
  FormNames.SECONDARY_REPORT,
  FormNames.RECOMMENDATION,
  FormNames.OPTIONAL_REPORT,
  FormNames.OPTIONAL_REPORT2,
  FormNames.MIDYEAR_REPORT,
  FormNames.FINAL_REPORT,
  FormNames.TEACHER_EVALUATION,
];

interface FormActionButtonsProps {
  onPreviewClick: () => void;
  onSaveForLaterClick: () => void;
  onSubmitClick: () => void;
  onUnsubmitClick: () => void;
  areAllActionsDisabled?: boolean;
  isSubmitDisabled?: boolean;
  isFormSumbitted: boolean;
  formName: FormNames;
}

export const FormActionButtons: React.FC<FormActionButtonsProps> = ({
  onPreviewClick,
  onSaveForLaterClick,
  onSubmitClick,
  onUnsubmitClick,
  areAllActionsDisabled,
  isSubmitDisabled,
  formName,
  isFormSumbitted,
}) => {
  const [isOpenConfirmationMessage, setIsOpenConfirmationMessage] = useState(false);

  const handleOpenConfirmationMessage = () => {
    setIsOpenConfirmationMessage(true);
  };

  const handleUnsubmit = async () => {
    void onUnsubmitClick();
  };

  const isShowUnsubmitBtn = FORMS_WITH_UNSUBMIT.includes(formName);

  return (
    <CoreBox
      sx={{
        gap: '0.5rem',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {isFormSumbitted ? (
        <>
          <ActionButton
            data-testid="reviewBtn"
            variant="outlined"
            onClick={onPreviewClick}
            disabled={areAllActionsDisabled}
          >
            Review submitted form
          </ActionButton>

          {isShowUnsubmitBtn ? (
            <ActionButton
              data-testid="unsubmitBtn"
              onClick={handleOpenConfirmationMessage}
              disabled={areAllActionsDisabled || isSubmitDisabled}
            >
              {formName === FormNames.TEACHER_EVALUATION ? 'Unsubmit evaluation' : 'Unsubmit form'}
            </ActionButton>
          ) : null}
        </>
      ) : (
        <>
          <ActionButton
            data-testid="previewBtn"
            variant="text"
            onClick={onPreviewClick}
            disabled={areAllActionsDisabled}
          >
            Preview
          </ActionButton>

          <ActionButton
            data-testid="saveforLaterBtn"
            variant="outlined"
            onClick={onSaveForLaterClick}
            disabled={areAllActionsDisabled}
          >
            Save for later
          </ActionButton>

          <ActionButton
            data-testid="submitBtn"
            onClick={onSubmitClick}
            disabled={areAllActionsDisabled || isSubmitDisabled}
          >
            Review and submit
          </ActionButton>
        </>
      )}

      {isOpenConfirmationMessage ? (
        <ConfirmationMessage
          icon={<WarningAmberIcon />}
          title={formName === FormNames.TEACHER_EVALUATION ? 'Unsubmit evaluation?' : 'Unsubmit form?'}
          subtitle="You may unsubmit this form any time before a college downloads it. Once a college downloads this form, you will no longer be able to withdraw it."
          goNextButtonTitle="Unsubmit"
          isOpenConfirmationMessage={isOpenConfirmationMessage}
          setIsOpenConfirmationMessage={setIsOpenConfirmationMessage}
          onGoNextBtnClick={handleUnsubmit}
        />
      ) : null}
    </CoreBox>
  );
};
